<template>
  <section
    v-if="shopifyData.checkSection == 'true'"
    class="text_box"
    :style="{ backgroundColor: backgroundColor }"
  >
    <!-- Sec Content -->
    <div class="sec_content">
      <h4 class="subtitle_b" v-html="shopifyData.secSubHeading" />
      <p
        v-for="(item, key) in shopifyData.secInfo"
        :key="key"
        class="body_text"
        v-html="item.secInfo"
      />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    backgroundColor() {
      return window.innerWidth <= 768
        ? this.shopifyData.sectionColorMob
        : this.shopifyData.sectionColorDesktop;
    },
  },
};
</script>
<style scoped>
.text_box {
  padding-top: 45px;
}
.sec_content {
  max-width: 564px;
  margin: 0 auto;
  padding: 0 11px 0 13px;
}
.subtitle_b {
  margin-bottom: 15px;
}
.body_text {
  margin-bottom: 20px;
}
.body_text:last-child {
  margin-bottom: 0px;
}
@media screen and (max-width: 767px) {
  .text_box {
    padding-top: 28px;
  }
}
</style>
